exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#admin-page[data-v-09421f4e]{background:#fcfdff;max-width:1400px;margin:auto}#pillarDeck[data-v-09421f4e]{padding:5em 10em;display:-webkit-box;min-width:1400px}#left_bubble[data-v-09421f4e]{left:-.8em;top:-1em}[data-v-09421f4e] .floating_arrow{position:absolute;right:-1.8em;top:34%;z-index:10;width:56px}[data-v-09421f4e] .fixed_height{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column;flex-flow:column;-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto}[data-v-09421f4e] p{color:#010407}[data-v-09421f4e] strong{font-weight:700!important}", ""]);

// exports
